<template>
  <div class="expired-container animated fadeInUp">
    <v-flex tag="h3">
      {{ $t("view.login.expiredPwd.title") }}
    </v-flex>
    <v-subheader>{{ $t("view.login.expiredPwd.instructions") }}</v-subheader>
    <form @submit.prevent @keyup.enter="changePassword">
      <!-- Old Password -->
      <v-text-field
        v-model="$v.auth.password.$model"
        prepend-icon="lock"
        name="password"
        :disabled="view.action.changePassword.busy"
        :error-messages="$t(`validator.${getFirstError($v.auth.password)}.text`, '')"
        :label="$t('view.login.expiredPwd.password.placeholder')"
        :type="show1 ? 'text' : 'password'"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show1 = !show1" />

      <!-- New Password -->
      <v-text-field
        v-model="$v.auth.newpassword.$model"
        prepend-icon="lock"
        name="password"
        :disabled="view.action.changePassword.busy"
        :error-messages="$t(`validator.${getFirstError($v.auth.newpassword)}.text`, '')"
        :label="$t('view.login.expiredPwd.newpassword.placeholder')"
        :type="show2 ? 'text' : 'password'"
        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show2 = !show2" />

      <!-- New Password Confirmation-->
      <v-text-field
        v-model="$v.auth.confirmpassword.$model"
        prepend-icon="lock"
        name="password"
        :disabled="view.action.changePassword.busy"
        :error-messages="$t(`validator.${getFirstError($v.auth.confirmpassword)}.text`, '')"
        :label="$t('view.login.expiredPwd.confirmpassword.placeholder')"
        :type="show3 ? 'text' : 'password'"
        :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show3 = !show3" />

      <label v-if="hasErrors($v.auth.confirmpassword)" class="error--text" for="password">
        {{ getConfirmPasswordErrorDescription }}
      </label>

      <div class="form-group">
        <label v-if="view.elem.label.changePasswordError.visible" for="error" class="error--text">
          {{ errorChangePasswordMessage }}
        </label>
        <v-btn :disabled="hasErrors($v.auth) || view.action.changePassword.busy" name="loginSubmit" block color="primary" @submit="changePassword()" @click="changePassword()">
          {{ $t("view.login.expiredPwd.submit") }}
        </v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import Auth from "@/services/auth";
import * as actions from "@/constants/mutation-names";
import transform from "@/helpers/transformations";
import { AuthenticationModel } from "@/models/authentication";
import { required, sameAs } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { valueIsWithin } from "@/helpers/validators";

const label = {
  changePasswordError: {
    visible: false
    , text: ""
  }
};

const button = { changePassword: { enable: true } };

const action = { changePassword: { busy: false } };

export default {
  name: "ExpiredPasswordModule"
  , data() {
    return {
      auth: undefined
      , locale: this.$i18n.language
      , show1: false
      , show2: false
      , show3: false
      , view: {
        title: this.$t("view.login.expiredPwd.title")
        , action
        , elem: {
          label
          , button
        }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    errorChangePasswordMessage() {
      return this.view.elem.label.changePasswordError.text;
    }
    , getConfirmPasswordErrorDescription() {
      const samePass = () => {
        return this.$t("view.login.expiredPwd.samePass");
      };
      return this.getFirstErrorDescription(this.$v.auth.confirmpassword, { samePass });
    }
  }
  , created() {
    if (this.$route.params.username) {
      this.setInitialState(this.$route.params.username);
    } else {
      this.$router.push("/401Unauthorized");
    }
  }
  , methods: {
    ...allValidatorMethods
    , async changePassword() {
      try {
        // Hide any previous error
        this.hideErrorChangePassword();
        // Validate all models before make the request
        if (!this.isAllValid(this.$v)) {
          return;
        }
        // Making request.
        this.view.action.changePassword.busy = true;
        const response = await Auth.changePassword(this.auth);
        this.view.action.changePassword.busy = false;
        // Managing the response
        let { data: { results: { token: userToken, usuario, roles } } } = response;
        const data = { ...transform.ResponseToUserStore(usuario), userToken, roles };
        this.$store.dispatch(actions.AUTH_LOGIN, data);
        this.$userPermission.set({ roles });
        this.$router.push("/home");
      } catch (error) {
        this.view.action.changePassword.busy = false;
        if (error && (error.status == "500" || error.status == "504")) {
          this.showErrorChangePassword(this.$t(`errors.network..${error.status}.desc`));
          return;
        }
        // Gettin the code error
        const { data: { meta: { code: errorCode } } } = error;
        if (valueIsWithin(Object.keys(this.$t("view.login.changePassword")), errorCode)) this.showErrorChangePassword(this.$t(`view.login.changePassword.${errorCode}.text`));
      }
    }
    , showErrorChangePassword(message) {
      this.view.elem.label.changePasswordError.visible = true;
      this.view.elem.label.changePasswordError.text = message;
    }
    , hideErrorChangePassword() {
      if (!this.view.elem.label.changePasswordError.visible) return;
      this.view.elem.label.changePasswordError.visible = false;
      this.view.elem.label.changePasswordError.text = "";
    }
    , setInitialState(username) {
      this.auth = new AuthenticationModel();
      this.auth.username = username;
      this.view.elem.label.changePasswordError.visible = true;
      this.view.elem.label.changePasswordError.text = "";
    }
  }
  , validations: {
    auth: {
      password: { required }
      , newpassword: { required }
      , confirmpassword: {
        required
        , sameAs: sameAs("newpassword")
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.expired-container {
  position: relative;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ExpiredPassword.vue